
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11 23","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.869 8.433c.54.575 1.262.959 1.983 1.15 1.082.384 1.984.959 2.886 1.917.901.767 1.262 2.108 1.262 3.258 0 1.342-.541 2.875-1.443 3.834-.72.766-1.623 1.341-2.705 1.533V23H4.87v-2.492c-1.082 0-2.164-.575-3.066-1.15A8.839 8.839 0 010 17.442l1.803-2.109c.36.575.902 1.15 1.443 1.534.54.575 1.443.766 2.164.766.54 0 1.262-.191 1.803-.766.36-.575.541-1.15.541-1.725 0-.575-.18-1.15-.54-1.534-.542-.383-1.263-.766-1.804-.958-1.082-.575-2.344-1.15-3.246-2.108-.721-.767-1.082-1.917-1.082-3.067-.18-1.15.36-2.3 1.082-3.258.721-.767 1.623-1.342 2.525-1.534V0h2.163v2.683c.722 0 1.443.192 1.984.575.541.384 1.082.767 1.623 1.342L8.836 6.9c-.54-.767-1.443-1.342-2.525-1.342-.54-.191-1.081.192-1.622.575-.361.192-.541.767-.541 1.15 0 .384.18.959.72 1.15z"}})])
          )
        }
      }
    